import { getGlobalLogger, LoggerMemoryHandler, LogLevelAll } from '@zeed/zeed'

export const logging = {
  messages: [],
}

export function setupLogging() {
  if (!localStorage.getItem('zeed')) {
    getGlobalLogger().registerHandler(LoggerMemoryHandler({
      level: LogLevelAll,
      filter: '*',
      compact: true,
      messages: logging.messages,
    }))

    // const log = Logger('console')
    // logCaptureConsole(log)

    // window.addEventListener('error', (event) => {
    //   log.error('Catched unhandled error', event)
    // })

    // window.addEventListener('unhandledrejection', (event) => {
    //   log.error('Catched unhandled rejection', event)
    // })

    // log.info('capturing mode for console')
  }

  return logging
}
